import { TraitRegistry, TraitType } from '../../trait-registry';
import { Trait } from '../../trait.type';
import { addModifier } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';
import { AmmoType } from '../../ammo.type';

export class ArcherTrait extends Trait {
  static baseType = TraitType.Archer;
  static baseTitle = 'Archer';
  static baseText =
    'At the start of turn, if you have less than 2 ammo, gain up to 2 Ammo (Basic).';
  static baseIcon = 'trait';

  type = ArcherTrait.baseType;
  title = ArcherTrait.baseTitle;
  text = ArcherTrait.baseText;
  icon = ArcherTrait.baseIcon;

  startTurn(): void {
    const ammo = this.owner.statusEffects.find((modifier) => modifier.type === StatusEffect.Ammo);
    if (ammo && ammo.stacks < 2) {
      ammo.update(2 - ammo.stacks, { ammoType: AmmoType.Blank });
    }
    if (ammo && ammo.stacks >= 2) {
      // do nothing
    } else {
      addModifier(this.owner, StatusEffect.Ammo, 2, { ammoType: AmmoType.Blank });
    }
  }
}

TraitRegistry.register(ArcherTrait.baseType, ArcherTrait);
